import React, { Fragment } from "react";
import { withTranslation } from "react-i18next";
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import { Col, Row } from "reactstrap";
import { Bar } from 'react-chartjs-2';
import PageTitle from "Layout/Components/PageTitle";
import BoxValue from "./BoxValue";
import { statisticsUsers } from "API/StatisticsAPI";

class StatisticsUsers extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      today: this.buildData(),
      last7Days: this.buildData(),
      last30Days: this.buildData(),
      last2Years: this.buildData()
    }
  }

  buildData() {
    return {
      total: 0,
      details: []
    };
  }

  componentDidMount() {
    statisticsUsers().then(result => {
      this.setState({
        today: result.data.find(item => item.period === 1),
        last7Days: result.data.find(item => item.period === 7),
        last30Days: result.data.find(item => item.period === 30),
        last2Years: result.data.find(item => item.period === 10000)
      });
    }).catch((error) => {
      console.error("Error fetching statistics data:", error);
    });
  }

  render() {
    const { t, i18n } = this.props;

    const { today, last7Days, last30Days, last2Years } = this.state;

    const buildGraphOptions = () => {
      return {
        maintainAspectRatio: true,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              stepSize: 1
            }
          }]
        }
      };
    }

    const graphData = {
      labels: [t("statistics.today"), t("statistics.last-7-days"), t("statistics.last-30-days"), t("statistics.last-2-years")],
      datasets: [
        {
          label: t("statistics.new-users"),
          data: [today.total, last7Days.total, last30Days.total, last2Years.total],
          borderWidth: 1,
          fill: true,
        }
      ]
    };

    return (
      <Fragment>
        <PageTitle
          heading={t("statistics.users.title")}
          icon="pe-7s-graph2 icon-gradient bg-primary"
        />
        <CSSTransitionGroup
          component="div"
          transitionName="TabsAnimation"
          transitionAppear={true}
          transitionAppearTimeout={0}
          transitionEnter={false}
          transitionLeave={false}>
          <Row>
            <Col md="3">
              <BoxValue heading={t("statistics.today")} value={today.total} />
            </Col>
            <Col md="3">
              <BoxValue heading={t("statistics.last-7-days")} value={last7Days.total} />
            </Col>
            <Col md="3">
              <BoxValue heading={t("statistics.last-30-days")} value={last30Days.total} />
            </Col>
            <Col md="3">
              <BoxValue heading={t("statistics.last-2-years")} value={last2Years.total} />
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <div className="text-center">
                <h5>{t("statistics.new-users")}</h5>
              </div>
              <Bar data={graphData} options={buildGraphOptions()} height={100} />
            </Col>
          </Row>
        </CSSTransitionGroup>
      </Fragment>
    )
  }
}

export default withTranslation()(StatisticsUsers);